import { getClient } from '@api/client';
import extractErrorMessage from '@lib/utils/extractErrorMessage';
import { DEACTIVATE_INTERACTION_MUTATION } from './mutations';

const deactivateInteraction = async (channelId: string): Promise<boolean> => {
  try {
    const { data } = await getClient().mutate({
      mutation: DEACTIVATE_INTERACTION_MUTATION,
      variables: { channelId },
    });

    if (data?.deactivateInteraction == null) {
      throw new Error('No data');
    }

    return data.deactivateInteraction;
  } catch (err) {
    throw new Error(extractErrorMessage(err), { cause: err });
  }
};

export default deactivateInteraction;
